import useMediaQuery from './useMediaQuery';

/**
 * True when the visitor has asked their OS to reduce motion. Used to skip
 * count-ups and staggered entrances; the CSS carries its own media query for
 * everything expressed in stylesheets.
 */
export default function usePrefersReducedMotion() {
  return useMediaQuery('(prefers-reduced-motion: reduce)');
}
